export default __webpack_public_path__ + "static/media/lock-private.00331f37.svg";